<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>波次单详情</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
          "
          :span="24"
        >
          基本信息
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="100"
            :data="resData.base"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="center"
              prop="as_wave_picking_no"
              label="波次号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="user_id"
              label="用户id"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="consignee"
              label="收货人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="address"
              label="收货人地址"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="wave_picking_num"
              label="待发总件数"
            ></el-table-column>
          </el-table>
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="100"
            :data="resData.base"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="center"
              prop="shipping_company"
              label="快递公司"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="shipping_num"
              label="快递单号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="weight"
              label="重量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              label="波次时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="update_time"
              label="更新时间"
            ></el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>

    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
          :span="24"
        >
          <span>商品信息</span>
          <el-input
            v-model="form.goods_no"
            size="mini"
            style="width: 120px; margin-left: auto"
            placeholder="商品货号"
            @keyup.native.enter="search"
          ></el-input>
          <el-input
            v-model="form.sku"
            size="mini"
            style="width: 120px"
            placeholder="sku"
            @keyup.native.enter="search"
          ></el-input>
          <el-button type="primary" size="mini" @click="search">查询</el-button>
          <el-button
            type="primary"
            size="mini"
            @click="dialogFormVisible = true"
            >标号删除</el-button
          >
          <el-dialog
            v-loading="loading"
            title="标号删除"
            :visible.sync="dialogFormVisible"
            width="30%"
            center
          >
            <el-form :model="form">
              <el-input v-model="form.dbid" placeholder="请输入内容"></el-input>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取 消</el-button>
              <!--<el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>-->
              <el-button type="primary" @click="delDbid">确 定</el-button>
            </div>
          </el-dialog>
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.info"
            tooltip-effect="dark"
            style="width: 100%"
            :row-class-name="tableRowClassName"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="center"
              prop="goods_name"
              label="商品名称"
            ></el-table-column>
            <el-table-column
              prop="img"
              label="图片"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    :src="scope.row.img"
                    alt=""
                    style="width: 100%; height: 100%"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="goods_no"
              label="商品货号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="co_val"
              label="颜色"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="si_val"
              label="尺码"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="sku"
              label="sku"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="init_num"
              label="原始数量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="wave_picking_info_num"
              label="数量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="no_ss_num"
              label="无仓位数量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="shop_price"
              label="平台价"
            ></el-table-column>
            <el-table-column align="center" prop="work_id" label="工单id">
              <!--<template slot-scope="scope">-->
              <!--<a style="width: 160px;margin: 0px;cursor: pointer" @click="getOrderId(scope.row.order_sn)">-->
              <!--{{scope.row.order_sn}}-->
              <!--</a>-->
              <!--</template>-->
            </el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              label="创建时间"
            ></el-table-column>

            <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button type="text" @click="delInfo(scope.row)"
                  >删除</el-button
                >
                <el-button type="text" @click="openDetail(scope.row)"
                  >详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>

          <el-dialog title="详情" :visible.sync="detailVisible">
            <el-input
              v-model="form.new_dbid"
              size="mini"
              style="width: 120px; margin-left: auto"
              placeholder="打标ID"
              @keyup.native.enter="searchDbid"
            ></el-input>
            <el-button type="primary" size="mini" @click="searchDbid"
              >查询</el-button
            >
            <el-table :data="infoDetail" :row-class-name="tableRowClassName">
              <el-table-column
                prop="img"
                label="商品图片"
                show-overflow-tooltip
                align="center"
              >
                <template slot-scope="scope">
                  <div
                    v-viewer
                    style="
                      width: 40px;
                      height: 40px;
                      overflow: hidden;
                      cursor: pointer;
                      margin: auto;
                    "
                  >
                    <img
                      :src="scope.row.img"
                      alt=""
                      style="width: 100%; height: 100%"
                    />
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                property="goods_name"
                label="商品名称"
                align="center"
              ></el-table-column>
              <el-table-column
                property="goods_no"
                label="商品货号"
                align="center"
              ></el-table-column>
              <el-table-column
                property="co_val"
                label="颜色"
                align="center"
              ></el-table-column>
              <el-table-column
                property="si_val"
                label="尺码"
                align="center"
              ></el-table-column>
              <el-table-column
                property="shop_price"
                label="平台价"
                align="center"
              ></el-table-column>
              <!--<el-table-column property="dbid" label="打标ID" align="center"></el-table-column>-->
              <!--<el-table-column property="update_time" label="校验时间" align="center"></el-table-column>-->
              <el-table-column prop="dbid" label="打标ID">
                <template slot-scope="scope">
                  <span>{{ scope.row.dbid == 0 ? "" : scope.row.dbid }}</span>
                </template>
              </el-table-column>
              <el-table-column
                property="ss_id"
                label="仓位id"
                align="center"
              ></el-table-column>
              <el-table-column
                property="admin_name"
                label="校验人"
                align="center"
              ></el-table-column>
              <el-table-column prop="update_time" label="校验时间">
                <template slot-scope="scope">
                  <span>{{
                    scope.row.update_time == "1970-01-01 08:00:00"
                      ? ""
                      : scope.row.update_time
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                  <el-button type="text" @click="delDbid(scope.row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>

            <el-pagination
              :current-page.sync="detailcurPage"
              background
              layout="total, prev, pager, next, jumper "
              :total="infoDetail_pages"
              :page-size="20"
              @current-change="handleCurrentChange2"
            ></el-pagination>
          </el-dialog>

          <el-dialog
            :before-close="handleDelClose"
            title="删除"
            :visible.sync="delVisible"
            width="30%"
            center
          >
            <el-form v-if="del_multiple" :model="form">
              <el-form-item v-for="item in form.del_type" :key="item.name">
                <el-row>
                  <el-row>
                    <el-col :span="9">{{ item.name }}</el-col>
                    <el-col :span="7">
                      <el-input-number
                        v-model="item.num"
                        :min="0"
                        size="mini"
                      ></el-input-number>
                    </el-col>
                    <el-col :span="6">
                      <el-input
                        v-model="item.remark"
                        size="mini"
                        placeholder="备注"
                      ></el-input>
                    </el-col>
                  </el-row>
                </el-row>
              </el-form-item>
            </el-form>
            <el-form v-if="!del_multiple" :model="form">
              <el-form-item
                v-for="(item, index) in form.del_type"
                :key="item.type"
                label=""
              >
                <el-row>
                  <el-col :span="12">
                    <el-radio
                      v-model="form.del_type_value"
                      :label="item.type"
                      @change="setDelData(index)"
                      >{{ item.name }}
                    </el-radio>
                  </el-col>
                  <el-col :span="12">
                    <el-input
                      v-model="item.remark"
                      placeholder="备注"
                    ></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="handleDelClose">取 消</el-button>
              <el-button type="primary" @click="doDel()">确 定</el-button>
            </div>
          </el-dialog>
        </div>

        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.count"
            :page-size="100"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>

    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
          "
          :span="24"
        >
          操作记录
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="300"
            :data="resData.log"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column prop="operator_name" label="操作人">
              <template slot-scope="scope">
                <span>{{
                  scope.row.operator_name == 0 ? "" : scope.row.operator_name
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="action_content"
              label="操作方式"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="result"
              label="结果"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_date"
              label="操作时间"
            ></el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: {},
      form: {
        del_type: [],
        dbid: "",
        wave_picking_info_id: 0,
        wave_picking_dbid_id: 0,
        wave_picking_id: this.$route.params.id,
      },
      msg: "",
      del_multiple: true,
      loading: false,
      tableLoading: false,
      url: "/erp/asWavePickingInfo/index",
      curPage: 1,
      detailcurPage: 1,
      filterFold: false,
      isAll: false,
      wave_picking_id: this.$route.params.id,
      detailVisible: false,
      delVisible: false,
      wave_picking_info_id: 0,
      infoDetail_pages: 0,
      infoDetail: [],
      dialogFormVisible: false,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (row.ss_id == 0 && this.resData.base[0].status == 10) {
        return "warning-row";
      }
      if (row.no_ss_num > 0 && this.resData.base[0].status == 10) {
        return "warning-row";
      }
      return "";
    },
    getOrderId(order_sn) {
      this.$http
        .post("/erp/WavePicking/getOrderLink", { order_sn })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(res.data.data);
          }
        });
    },
    doDel() {
      let delNum = 0;
      this.form.del_type.forEach((item, key) => {
        delNum += item.num;
      });
      if (delNum == 0) {
        this.$message.error("删除0件？ (‧_‧？)", "提示");
        return false;
      }
      this.loading = true;
      let msg = `是否删除${delNum}件商品<br>`;
      this.form.del_type.forEach((item, key) => {
        if (item.num > 0) {
          msg = `${msg + item.name}：${item.num}件<br>`;
        }
      });
      this.$confirm(msg, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        center: true,
      }).then(() => {
        if (this.form.dbid) {
          this.$http
            .post("/erp/asWavePickingInfo/delDbid", this.filteredForm)
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message.e(res.data.msg);
              } else {
                this.delVisible = false;
                this.detailVisible = false;
                this.handleDelClose();
                this.$message.success(res.data.msg);
                this.fetchData(true);
              }
            });
        } else {
          this.$http
            .post("/erp/asWavePickingInfo/del", this.filteredForm)
            .then((res) => {
              this.loading = false;
              if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
              } else {
                this.delVisible = false;
                this.handleDelClose();
                this.$message.success(res.data.msg);
                this.fetchData(true);
              }
            });
        }
      });
      this.msg = "";
      this.loading = false;
    },
    setDelData(index) {
      this.form.del_type.map((item, index) => {
        if (item.num > 0) {
          item.num = 0;
          item.remark = "";
        }
        return item;
      });
      this.form.del_type[index].num = 1;
    },
    delInfo(row) {
      console.log(row);
      setTimeout(() => {
        this.loading = false;
      }, 200);
      this.form.wave_picking_info_id = row.as_wave_picking_info_id;
      this.delVisible = true;
      if (row.wave_picking_info_num > 1) {
        this.del_multiple = true;
      } else {
        this.del_multiple = false;
      }
    },
    delDbid(row) {
      console.log(row);
      if (row.dbid > 0) {
        this.form.dbid = row.dbid;
      } else {
        this.form.wave_picking_dbid_id = row.as_wave_picking_dbid_id;
      }
      this.form.wave_picking_info_id = row.as_wave_picking_info_id;
      this.del_multiple = false;
      this.delVisible = true;
    },
    openDetail(row) {
      this.detailcurPage = 1;
      this.wave_picking_info_id = row.as_wave_picking_info_id;
      this.infoDetail_pages = row.wave_picking_info_num;
      this.$http
        .get(
          `/erp/asWavePickingInfo/detail/wave_picking_info_id/${row.as_wave_picking_info_id}`
        )
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.infoDetail = res.data.data;
            this.detailVisible = true;
          }
        });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http
        .post(
          `${this.url}/wave_picking_id/${this.wave_picking_id}`,
          this.filteredForm
        )
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.resData = res.data.data.wave_data;
            this.form.del_type = res.data.data.del_type;
          }
        });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      for (const key in val) {
        multipleSelection[key] = {
          id: val[key].id,
        };
      }
      this.form.multipleSelection = JSON.stringify(multipleSelection);
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    // 切换页码
    handleCurrentChange2(val) {
      this.form.page = val;
      this.$http
        .get(
          `/erp/asWavePickingInfo/detail/wave_picking_info_id/${this.wave_picking_info_id}/page/${val}`
        )
        .then((res) => {
          setTimeout(() => {
            this.tableLoading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.infoDetail = res.data.data;
          }
        });
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data.wave_data;
        }
      });
    },
    handleDelClose() {
      this.delVisible = false;
      this.form = {
        del_type: this.form.del_type.map((item) => {
          item.num = 0;
          item.remark = "";
          return item;
        }),
        dbid: "",
        cancel_order_del_num: 0,
        stock_diff_del_num: 0,
        wave_picking_info_id: 0,
        wave_picking_dbid_id: 0,
        wave_picking_id: this.$route.params.id,
      };
    },
    searchDbid() {
      this.detailcurPage = 1;
      this.$http
        .post(
          `/erp/asWavePickingInfo/detail/wave_picking_info_id/${this.wave_picking_info_id}`,
          this.filteredForm
        )
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.infoDetail = res.data.data;
          }
        });
    },
    trim(str, is_global) {
      let result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (is_global.toLowerCase() == "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/aswavepicking/AsWavePickingInfo.vue